import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=5befbee5&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=5befbee5&prod&scss=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befbee5",
  null
  
)

export default component.exports